import JoditEditor from "jodit-react";
import React, { useEffect, useRef, useState } from "react";
import { MdCancel, MdOutlineCloudUpload } from "react-icons/md";
import {
  useCreateBlogMutation,
  useGetBlogByIdQuery,
  useUpdateBlogMutation,
} from "../../redux/blogApi";
import { useNavigate, useParams } from "react-router-dom";
import ButtonLoading from "../Button loading/ButtonLoading";
import { toast } from "react-toastify";
import { showErrorToast } from "../../utils/Utils";
const config = {
  uploader: {
    insertImageAsBase64URI: true,
  },
  defaultActionOnPaste: "insert_only_text",
  askBeforePasteHTML: false,
  askBeforePasteFromWord: false,
};
const CreateBlog = () => {
  const fileInputRef = useRef(null);
  const [image, setImage] = useState(null);
  const [error, setError] = useState("");
  const [formData, setFormData] = useState({
    title: "",
    currentStatus: "draft",
    Keywords: "",
    content: "",
  });
  const [createBlog, { isLoading: isCreateLoading }] = useCreateBlogMutation();
  const [updateBlog, { isLoading: isUpdateLoading }] = useUpdateBlogMutation();
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});

  const { id } = useParams();
  const isEditMode = Boolean(id);

  const { data, isLoading: isBlogLoading } = useGetBlogByIdQuery(id, {
    refetchOnFocus: false,
    skip: !isEditMode,
  });

  useEffect(() => {
    if (isEditMode && data) {
      setFormData({
        title: data?.blog?.title,
        currentStatus: data?.blog?.status,
        content: data?.blog?.content,
        Keywords: data?.blog?.tags?.join(", "),
      });

      if (data?.blog?.coverImage?.imageUrl) {
        setImage({
          src: data?.blog?.coverImage?.imageUrl,
          file: null,
        });
      }
    }
  }, [isEditMode, data]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };
  const handleDescriptionChange = (value) => {
    setFormData({
      ...formData,
      content: value,
    });
  };
  const handleDrop = (e) => {
    e.preventDefault();
    const files = Array.from(e.dataTransfer.files);
    if (files.length > 0) {
      handleFile(files[0]);
    }
  };

  const handleFile = (file) => {
    setError("");

    if (!file) {
      setError("No file selected.");
      return;
    }

    if (file.size > 10 * 1024 * 1024) {
      setError("Image size must be less than 10MB.");
      return;
    }

    const objectUrl = URL.createObjectURL(file);
    const img = new Image();

    img.onload = () => {
      // if (img.width !== 1610 || img.height !== 650) {
      //   setError("Image dimensions must be exactly 1610 x 650 pixels.");
      //   URL.revokeObjectURL(objectUrl);
      //   return;
      // }

      const newImage = {
        src: objectUrl,
        file,
      };

      setImage(newImage);
    };

    img.onerror = () => {
      setError("Invalid image file.");
      URL.revokeObjectURL(objectUrl);
    };

    img.src = objectUrl;
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDelete = () => {
    setImage(null);
    setError("");
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const validateForm = () => {
    const newErrors = {};
    let isValid = true;
    setError("");

    if (!formData.title.trim()) {
      newErrors.title = "Title is required.";
      isValid = false;
    }

    if (!formData.currentStatus.trim()) {
      newErrors.currentStatus = "Current Status is required.";
      isValid = false;
    }

    if (!formData.Keywords.trim()) {
      newErrors.Keywords = "Keywords is required.";
      isValid = false;
    }

    if (!formData.content.trim()) {
      newErrors.content = "Description is required.";
      isValid = false;
    }

    if (!image) {
      setError("Please upload an image.");
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }
    const blogData = new FormData();
    blogData.append("title", formData.title);
    blogData.append("status", formData.currentStatus);
    blogData.append("content", formData.content);
    blogData.append("tags", formData.Keywords);
    blogData.append("coverImage", image?.file);

    try {
      let response = null;
      if (isEditMode) {
        response = await updateBlog({ id, blogData: blogData }).unwrap();
      } else {
        response = await createBlog(blogData).unwrap();
      }

      if (response.success) {
        handleCancel();
        toast.success(response.message);
        navigate("/blogs");
      }
    } catch (err) {
      console.error("blog error:", err);
      showErrorToast(err);
    }
  };

  const handleCancel = () => {
    setFormData({
      title: "",
      currentStatus: "",
      Keywords: "",
      content: "",
    });
    setErrors({});
    setImage(null);
    setError("");
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  return (
    <div className="flex flex-col gap-3 bg-white rounded-xl xl:p-8 lg:p-6 p-4 ">
      <h1 className="text-[#05004E] lg:text-[1.8rem] md:text-[1.4rem] text-[1.2rem] font-semibold">
        {isEditMode ? "Update" : "Create"} Blog
      </h1>
      {isBlogLoading ? (
        <div className="flex flex-col gap-4">
          <div className="flex flex-col gap-1 ">
            <div className=" w-full h-24 rounded-xl bg-[#efefef] animate-pulse"></div>
          </div>
          <div className="grid grid-cols-2 gap-6">
            <div className="flex flex-col gap-1 ">
              <div className="h-6 w-40 bg-[#efefef] animate-pulse rounded-lg"></div>
              <div className=" w-full h-12 rounded-xl bg-[#efefef] animate-pulse"></div>
            </div>
            <div className="flex flex-col gap-1 ">
              <div className="h-6 w-40 bg-[#efefef] animate-pulse rounded-lg"></div>
              <div className=" w-full h-12 rounded-xl bg-[#efefef] animate-pulse"></div>
            </div>
          </div>
          <div className="flex flex-col gap-1 ">
            <div className="h-6 w-40 bg-[#efefef] animate-pulse rounded-lg"></div>
            <div className=" w-full h-12 rounded-xl bg-[#efefef] animate-pulse"></div>
          </div>
          <div className="flex flex-col gap-1 ">
            <div className="h-6 w-40 bg-[#efefef] animate-pulse rounded-lg"></div>
            <div className=" w-full h-32 rounded-xl bg-[#efefef] animate-pulse"></div>
          </div>
          <div className="flex items-center justify-end gap-4">
            <div className="w-[10rem]  rounded-xl h-14 bg-[#efefef] animate-pulse"></div>
            <div className="w-[10rem]  rounded-xl h-14 bg-[#efefef] animate-pulse"></div>
          </div>
        </div>
      ) : (
        <form
          className="flex flex-col lg:gap-4 md:gap-3 gap-2 lg:text-[1rem] text-[.9rem]"
          onSubmit={handleSubmit}
        >
          <div>
            <div
              className="w-full border border-[#00000033] md:p-4 p-3 rounded-xl "
              onDragOver={handleDragOver}
              onDrop={handleDrop}
            >
              <label
                htmlFor="file-upload"
                className="cursor-pointer  flex flex-col md:gap-2 gap-1 items-center w-full "
              >
                <MdOutlineCloudUpload className="text-[#00643b] lg:size-10 md:size-8 size-6" />
                <p className="text-center font-semibold text-[#0B0B0B] ">
                  Drag your file(s) or{" "}
                  <span className=" text-[#00643b]  ">browse</span>
                </p>

                <p className="text-[#6D6D6D] text-center md:text-sm text-[12px]">
                  Max 10 MB files are allowed
                </p>
                <p className="text-[#6D6D6D] text-center md:text-sm text-[12px] ">
                  For best display, use a cover image with dimensions of
                  1610×650 pixels.
                </p>
              </label>

              <input
                id="file-upload"
                type="file"
                accept="image/*"
                onChange={(e) => handleFile(e.target.files[0])}
                className="hidden"
                ref={fileInputRef}
              />
              {image && (
                <div className="flex justify-center text-[#6D6D6D] items-center md:gap-4 gap-3 md:text-sm text-[12px] lg:py-[1.3rem] md:py-[1rem] py-[.5rem]">
                  <hr className="border-[#00000033] md:w-[22.22%] w-[30%] border-1" />
                  OR
                  <hr className="border-[#00000033] md:w-[22.22%] w-[30%] border-1" />
                </div>
              )}

              {image && (
                <div className="relative ">
                  <img
                    src={image.src}
                    alt="Upload Preview"
                    className=" object-cover w-full md:rounded-[1rem] rounded-lg "
                  />
                  <button
                    onClick={() => handleDelete()}
                    className="absolute md:-top-2.5 md:-right-2.5 -top-1.5 -right-1.5 bg-white rounded-full  "
                  >
                    <MdCancel className="lg:size-10 md:size-8 size-6 text-red-500" />
                  </button>
                </div>
              )}
            </div>
            {error && (
              <p className="text-red-500 md:text-sm text-[12px] ">{error}</p>
            )}
          </div>

          <div className=" flex items-stretch  w-full lg:gap-6 md:gap-4 gap-2">
            <div className="flex flex-col md:gap-1 gap-[2px] flex-1">
              <label className="font-semibold">Add Title</label>
              <input
                type="text"
                name="title"
                placeholder="Enter Title"
                value={formData.title}
                onChange={handleChange}
                className="w-full border border-[#00000033] text-[#737791] outline-none lg:p-4 md:p-3 p-2 lg:rounded-xl rounded-lg"
              />
              {errors.title && (
                <p className="text-red-500 md:text-sm text-[12px]">
                  {errors.title}
                </p>
              )}
            </div>
            {/* <div className="flex flex-col gap-1 flex-1">
            <label className="font-semibold">Add Location</label>
            <input
              type="text"
              name="location"
              placeholder="Enter Location"
              value={formData.location}
              onChange={handleChange}
              className="w-full border border-[#00000033] text-[#737791] outline-none p-4 rounded-xl"
            />
            {errors.location && (
              <p className="text-red-500 md:text-sm text-[12px] ">{errors.location}</p>
            )}
          </div> */}

            <div className="flex flex-col md:gap-1 gap-[2px]  flex-1">
              <label className="font-semibold">Current Status</label>
              <select
                name="currentStatus"
                value={formData.currentStatus}
                onChange={handleChange}
                className="w-full border border-[#00000033] text-[#737791] outline-none lg:p-4 md:p-3 p-2 lg:rounded-xl rounded-lg"
              >
                <option value="draft">Draft</option>
                <option value="published">Published</option>
              </select>

              {errors.currentStatus && (
                <p className="text-red-500 md:text-sm text-[12px] ">
                  {errors.currentStatus}
                </p>
              )}
            </div>
          </div>
          <div className=" flex items-stretch  w-full lg:gap-6 md:gap-4 gap-2">
            <div className="flex flex-col md:gap-1 gap-[2px] flex-1">
              <label className="font-semibold">Keywords</label>
              <input
                type="text"
                name="Keywords"
                placeholder="Enter Keywords"
                value={formData.Keywords}
                onChange={handleChange}
                className="w-full border border-[#00000033] text-[#737791] outline-none lg:p-4 md:p-3 p-2 lg:rounded-xl rounded-lg"
              />
              {errors.Keywords && (
                <p className="text-red-500 md:text-sm text-[12px] ">
                  {errors.Keywords}
                </p>
              )}
            </div>
          </div>

          <div className="flex flex-col md:gap-1 gap-[2px] ">
            <label className="font-semibold">Description</label>
            <div>
              <JoditEditor
                value={formData.content}
                config={config}
                onBlur={(newContent) =>
                  setFormData({ ...formData, content: newContent })
                }
                placeholder="Write your blog ..."
                className="w-full border border-[#00000033] text-[#737791] outline-none lg:p-4 md:p-3 p-2 lg:rounded-xl rounded-lg"
              />
            </div>
            {errors.content && (
              <p className="text-red-500 md:text-sm text-[12px] ">
                {errors.content}
              </p>
            )}
          </div>

          <div className="flex items-center justify-end lg:gap-4 md:gap-3 gap-2">
            <p
              onClick={() => handleCancel()}
              className="lg:w-[10rem] md:w-[9rem] w-max md:py-2 md:px-0 py-1 px-2 md:text-[1rem] text-[.85rem]  border  border-[#00643B] text-[#00643B] text-center cursor-pointer  lg:rounded-xl md:rounded-lg rounded-md font-medium"
            >
              Cancel
            </p>
            <button
              type="submit"
              disabled={isCreateLoading || isUpdateLoading ? true : false}
              className="lg:w-[10rem] md:w-[9rem] w-max md:py-2 md:px-0 py-1 px-2 md:text-[1rem] text-[.85rem]  border border-[#00643B] disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center text-white bg-[#00643B] lg:rounded-xl md:rounded-lg rounded-md font-medium"
            >
              {isEditMode ? (
                isUpdateLoading ? (
                  <ButtonLoading text="Update..." />
                ) : (
                  "Update"
                )
              ) : isCreateLoading ? (
                <ButtonLoading text="Create..." />
              ) : (
                "Create"
              )}
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

export default CreateBlog;
